module.exports = __webpack_public_path__ + "assets/media/status.740134fb.svg";